<template>
    <div class="mb-6">
        <div class="font-weight-bold h3">
            <slot/>
        </div>
        <div v-if="$slots.subtitle" class="mt-n1 text-muted">
            <slot name="subtitle"/>
        </div>
        <DividerDotted class="mt-3"/>
    </div>
</template>

<script>
import DividerDotted from "@components/Form/DividerDotted.vue";

export default {
    components: {DividerDotted}
}
</script>
